import { render } from "./modal-history.vue?vue&type=template&id=8a872560"
import script from "./modal-history.vue?vue&type=script&lang=js"
export * from "./modal-history.vue?vue&type=script&lang=js"
script.render = render

export default script